import "./style.scss";

const Title = () => {
  return <h1 className="title-1">Корзина товаров</h1>;
};

export default Title;
